import * as React from "react";
import { extractArtefactsFromString } from "@/modules/chat/chat.utils";
import type { Artefact } from "@/modules/chat/chat-ui.types";

export const useArtefactExtraction = (content: string): [string, Artefact[]] =>
  React.useMemo(() => extractArtefactsFromString(content), [content]);
